/**
 * 좌측 레일 브랜드 (2026-08-12) — 관리 콘솔 "회사정보 관리"의 로고를 반영한다.
 *
 * 규칙(사용자 지시):
 *   1) 관리 콘솔에서 로고를 등록하면 사용자 화면의 브랜드가 그 로고로 바뀐다.
 *   2) ~~로고가 있으면 아래 워드마크 텍스트는 표시하지 않고, 레일 폭을 꽉 채워 로고만 보인다.~~
 *      ★ **2026-09-07 폐기.** 그 규칙은 **세로 72px 레일**의 사정이었다 — 로고가 폭을 꽉 채우니
 *        글자를 놓을 자리가 없었다. 레일이 「접힘 56 ↔ 펼침 200 한 줄」이 되면서(정본 F16)
 *        펼침에는 자리가 생겼고, 사용자 지적대로 **로고 옆에 회사명이 있어야 한다**.
 *        접힘에서는 종전 규칙(`[data-collapsed] .navbar-title { max-width: 0 }`)이 그대로 감춘다.
 *   3) 브랜드를 클릭하면 대시보드(/dashboard)로 이동한다.
 * 로고 미등록·조회 실패 시에는 **AXI 브랜드 심볼** + 워드마크 'Axi' (2026-09-01).
 *   ★ 그전에는 파란 상자에 글자 'A' 였다. 그런데 로고를 지울 때 화면이 이미
 *     「사용자 사이트는 **기본 심볼**로 표시됩니다」라고 말하고 있었고, 디자인 정본도
 *     「① 좌측 레일 머리 = 심볼(회사 로고가 있으면 그것)」로 적어 두었다 —
 *     **말과 그림이 어긋나 있던 것**이라 그림을 말에 맞췄다.
 *   ★ 회사 로고가 등록되면 심볼은 그때 자리를 내준다(멀티테넌트 — 제품 브랜드와
 *     고객사 브랜드가 같은 자리를 다투지 않게).
 *
 * 로고 로드 실패(객체 없음·권한 등)는 onError 로 감지해 즉시 폴백으로 되돌린다 —
 * 깨진 이미지 아이콘이 레일에 남지 않도록.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useBrand } from '../../lib/brand-logo';
import { BrandSymbol } from '../BrandSymbol';

export function NavBarBrand() {
  const { logoSrc, companyName } = useBrand();
  const [failed, setFailed] = useState(false);

  // 로고가 교체되면(?v 토큰 변경) 실패 상태를 초기화해 새 이미지를 다시 시도한다.
  useEffect(() => { setFailed(false); }, [logoSrc]);

  const showLogo = Boolean(logoSrc) && !failed;

  return (
    <Link
      to="/dashboard"
      className={`navbar-brand navbar-brand--link${showLogo ? ' navbar-brand--logo' : ''}`}
      aria-label={companyName ? `${companyName} — 대시보드로 이동` : '대시보드로 이동'}
    >
      {showLogo ? (
        <>
          <img
            className="navbar-logo-img"
            src={logoSrc!}
            alt={companyName ?? '회사 로고'}
            onError={() => setFailed(true)}
          />
          {/* 회사명은 **로고를 따라간다** — 로고가 없으면 아래 제품 워드마크('Axi')가 그 자리다.
              둘을 같이 세우면 제품 브랜드와 고객사 브랜드가 한 자리를 다툰다(멀티테넌트). */}
          {companyName && <span className="navbar-title">{companyName}</span>}
        </>
      ) : (
        <>
          <BrandSymbol className="navbar-logo navbar-logo--symbol" aria-hidden />
          <span className="navbar-title">Axi</span>
        </>
      )}
    </Link>
  );
}
